<template>
  <Layout>
    <div
      v-if="step == 'register'"
      class="d-flex register-container justify-content-center align-items-center"
    >
      <b-card class="register-box">
        <div class="mb-4 box-title">Create your account</div>
        <div class="mb-4">
          Already have an account yet?
          <router-link :to="{ name: 'login' }">Log in account</router-link>
        </div>

        <div
          v-if="isShowRegError"
          class="alert alert-danger alert-outline alert-dismissible fade show"
          role="alert"
        >
          <i
            class="uil uil-exclamation-octagon font-size-16 text-danger me-2"
          ></i>
          {{ regErrorMessage }}
          <button
            type="button"
            class="btn-close"
            @click="closeRegError"
          ></button>
        </div>
        <div class="step-container">
          <div class="d-flex steps justify-content-around mb-2">
            <div class="d-flex flex-column">
              <div
                class="step-marker justify-content-center align-self-end d-flex"
                :class="{ active: subStep == 'user' }"
              >
                <img
                  class="align-self-center"
                  src="@/assets/images/user_details.png"
                  alt=""
                  height="16"
                  width="16"
                />
              </div>
            </div>
            <div class="d-flex justify-content-start">
              <div
                class="step-marker justify-content-center d-flex"
                :class="{ active: subStep == 'company' }"
              >
                <img
                  class="align-self-center"
                  src="@/assets/images/company_details.png"
                  alt=""
                  height="16"
                  width="16"
                />
              </div>
            </div>
          </div>
          <div class="bar-container d-flex justify-content-center h-100">
            <hr class="w-50" />
          </div>
        </div>

        <div class="d-flex justify-content-around mb-4">
          <div>
            <strong>General</strong>
          </div>
          <div>
            <strong>Business</strong>
          </div>
        </div>

        <user-detail-form
          class="mb-3"
          v-if="subStep == 'user'"
          v-model="user"
          @submit="checkUser()"
        />

        <company-detail-form
          class="mb-3"
          v-model="organization"
          :isRegisterLoading="isRegisterLoading"
          v-if="subStep == 'company'"
          @back="gotoStep('user')"
          @submit="userRegister"
        />

        <location-detail-form
          class="mb-3"
          v-if="subStep == 'location' && false"
          v-model="address"
          :isRegisterLoading="isRegisterLoading"
          @back="gotoStep('company')"
          @submit="userRegister"
        />

        <chat-support />
      </b-card>
    </div>

    <confirmation-form
      :username="user.email"
      v-if="step == 'confirmation'"
      @success="login"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import {
  authMethods,
  organizationMethods,
  authComputed,
} from "@/state/helpers";
import CompanyDetailForm from "./company-detail-form.vue";
import UserDetailForm from "./user-detail-form.vue";
import LocationDetailForm from "./location-detail-form.vue";
import ConfirmationForm from "./confirmation-form.vue";

const parsePhoneNumber = require("awesome-phonenumber").parsePhoneNumber;

export default {
  props: ['email'],
  data() {
    return {
      isShowRegError: false,
      regErrorMessage: null,
      isRegisterLoading: false,
      step: "register",
      subStep: "user",
      user: {
        name: null,
        email: null,
        phone_number: null,
        password: null,
        confirmPassword: null,
      },
      organization: {
        businessType: null,
        startHour: null,
        endHour: null,
        logo: {
          filename: null,
          type: null,
          base64: null,
        },
        name: null,
        contact_number: null,
      },
      address: {
        street: null,
        barangayId: null,
        cityId: null,
        provinceId: null,
        regionId: null,
      },
    };
  },
  computed: {
    ...authComputed,
  },
  methods: {
    ...authMethods,
    ...organizationMethods,
    closeRegError() {
      this.isShowRegError = false;
    },
    checkUser() {
      this.isUserAvailable(this.user.email).then((isAvailable) => {
        console.log("Is available:" + isAvailable);
        if (isAvailable) {
          this.regErrorMessage = null;
          this.isShowRegError = false;
          this.gotoStep("company");
        } else {
          this.regErrorMessage =
            "An account with the given email already exist.";
          this.isShowRegError = true;
        }
      });
    },
    async userRegister() {
      this.isRegisterLoading = true;
      this.isShowRegError = false;
      this.regErrorMessage = null;

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("signup");

      var phoneInternational = null;
      if (this.user.phone_number) {
        const pn = parsePhoneNumber(this.user.phone_number, {
          regionCode: "PH",
        });
        if (pn.number.international) {
          phoneInternational = pn.number.international.replace(/\s/g, "");
        }
      }

      this.register({
        username: this.user.email,
        password: this.user.password,
        email: this.user.email,
        phone_number: phoneInternational,
        name: this.user.name,
        captcha: token,
      })
        .then(() => {
          this.regErrorMessage = null;
          this.isShowRegError = false;
          this.isRegisterLoading = false;
          this.step = "confirmation";
        })
        .catch((err) => {
          this.regErrorMessage = err.message;
          this.isShowRegError = true;
          this.isRegisterLoading = false;
        });
    },
    async login() {
      this.logIn({
        username: this.user.email,
        password: this.user.password,
      })
        .then(() => {
          if (this.organization.logo.base64) {
            return this.uploadBusinessLogo(
              Object.assign(
                { cognitoSub: this.currentUser.cognitoSub },
                this.organization.logo
              )
            );
          }
          return false;
        })
        .then((key) => {
          if (key) {
            this.organization.logo = key;
          } else {
            this.organization.logo = null;
          }
          var org = Object.assign(this.organization, this.address);
          this.createOrganization(org)
            .then(() => {
              console.log("redirect to home"); 
              this.$router.push({ name: 'home' }) 
            })
            .catch(err => console.log(err));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    gotoStep(step) {
      console.log(this.organization);
      this.subStep = step;
    },
  },
  components: {
    Layout,
    CompanyDetailForm,
    UserDetailForm,
    ConfirmationForm,
    LocationDetailForm,
  },
  mounted() {
    const recaptcha = this.$recaptchaInstance;
    recaptcha.showBadge();
    if(this.email){
      this.user.email = this.email; 
    }
  },
  beforeDestroy() {
    const recaptcha = this.$recaptchaInstance;
    recaptcha.hideBadge();
  },
};
</script>

<style>
/* Register */
.register-box {
  width: 493px;
  border-radius: 8px;
}

.register-box .card-body {
  padding: 24px;
}

.register-box label {
  font-weight: 500;
  font-family: "Poppins";
}

.register-container {
  min-height: 900px;
  height: 80vh;
}

.register-container h3 {
  font-family: "Poppins";
}
/* End registration */

/* Confirmation */
.confirmation-box {
  width: 493px;
  border-radius: 8px;
}

.confirmation-box .card-body {
  padding: 24px;
}

.confirmation-box label {
  font-weight: 500;
  font-family: "Poppins";
}

.confirmation-container {
  height: 80vh;
}

.confirmation-container h3 {
  font-family: "Poppins";
}
/* End confirmation */

.red {
  color: #ff0000;
}

.cursor-pointer {
  cursor: pointer;
}

.step-marker {
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: solid 2px #e6eaf1;
  background: #c1c1c1;
}

.step-marker.active {
  background: #f84b04;
}

.step-separtor {
  height: 3px;
  background-color: #e1e1e1;
}

.step-container {
  position: relative;
}

.bar-container {
  position: absolute !important;
  top: 0;
  bottom: 0;
  width: 100%;
}

.bar-container hr {
  height: 3px;
  background-color: #e1e1e1;
}
</style>